import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class SearchService {
    private searchSubject = new BehaviorSubject<SearchContent[]>([]);
    searchResults$ = this.searchSubject.asObservable();

    setSearchResult(results: []) {
        this.searchSubject.next(results);
    }
}

class SearchContent {
    title: string;
    keywords: string;
    description: string;
    url: string;
}
